import _ from 'lodash'
export default {
  SET_CURRENT_SCREEN: (state, currentScreen) => { state.currentScreen = currentScreen },
  SET_CARD_SUFFER: (state, isSuffer) => {
    if (isSuffer) {
      state.sufferCard = isSuffer
    } else {
      state.sufferCard = !state.sufferCard
    }
  },
  SET_HOUSE_COLOR: (state, colorHorse) => { state.colorHorse = colorHorse },
  SET_RESULT: (state, isWin) => { state.isWin = isWin },
  SET_SOUND_MUTE: (state, soundMute) => { state.soundMute = soundMute },
  SET_DICE_DATA: (state, {currentDice, diceData}) => {
    if (currentDice === 'user') {
      _.assign(state.dice.user, diceData)
    } else {
      _.assign(state.dice.pc, diceData)
    }
  },
  SET_STOP_SUFFER_CARD: (state, isStop) => { state.isStopSufferCard = isStop },
  SET_HORSE_RUN: (state, {currentHorse, raceStatus}) => {
    if (currentHorse === 'user') {
      state.raceStage.user = raceStatus
    } else {
      state.raceStage.pc = raceStatus
    }
  },
  SET_DICE_RUN: (state, {currentDice, diceStatus}) => {
    if (currentDice === 'user') {
      state.diceStage.user = diceStatus
    } else {
      state.diceStage.pc = diceStatus
    }
  },
  SET_PC_DICE_STATUS: (state, isSake) => { state.pcDiceStatus = isSake },
  SHOW_RACE_TEXT_START: (state, isShow) => { state.showRaceTextStart = isShow },
  SHOW_RACE_TEXT_GOAL: (state, isShow) => { state.showRaceTextGoal = isShow },
  SET_REPLAY: (state, isReplay) => { state.replay = isReplay },
  SET_SPECIAL_TO_CARD: (state, cardID) => { state.adnSpecial = cardID },
  RESET_GAME: (state) => {
    state.horseUser = state.horsePc = state.array_temp = []
    state.arrayTotalDNA = state.arraySpecialDNA = state.specialCard = {}
    state.replay = state.replaySpecialcard
    state.temp = state.turn = 0
    state.replay = state.replaySpecialcard = state.isStopSufferCard = false
    state.dice = {
      user: [0, 0],
      pc: [0, 0]
    }
    state.isAsmallerB = true
    state.distanceOneTurnA = 0
    state.distanceOneTurnB = 0
    state.finalDistanceA = 0
    state.finalDistanceB = 0
    state.raceStage = {
      user: false,
      pc: false
    }
    state.diceStage = {
      user: false,
      pc: false
    }
    state.pcDiceStatus = false
    state.showRaceTextStart = false
    state.showRaceTextGoal = false
    // state.soundMute = false
    state.adnSpecial = -1
  },
  SET_RESET_STATUS: (state, isReset) => { state.resetStatus = isReset }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js